// extracted by mini-css-extract-plugin
export default {"container":"LikeButton_container__dYlnR","likeButton":"LikeButton_likeButton__KoAaK","label":"LikeButton_label__oOyfE"};